import React, { useCallback } from 'react';
import { AnyObject } from 'react-final-form';
import { useHistory } from 'react-router-dom';
import identity from 'lodash/identity';
import { useSelector } from 'react-redux';

import { getWorkspaceDisplayLabel } from 'Shared/selectors/workspace';
import DraftEditor from 'Shared/components/DraftEditor/DraftEditor';
import { editorStateForEditorComponent } from 'Shared/utils/draftJsHelpers';
import { meetingItemTypes } from 'Shared/constants/constants';
import RoundCheckbox from 'Shared/components/Checkboxes/RoundCheckbox/RoundCheckbox';

import './index.scss';

export default function ListItem({ item, onOpenToggle }: AnyObject) {
  const history = useHistory();
  const workspaceName = useSelector(getWorkspaceDisplayLabel(item.workspaceId));

  const handleClick = useCallback(() => {
    if (onOpenToggle) onOpenToggle();
    (window as any).analytics.track('Clicked Search Results', { type: 'workspace_item', item });
    setTimeout(() => history.push(`${item.workspacePath}/item/${item.uuid}`));
  }, [history, item, onOpenToggle]);

  return (
    <div onClick={handleClick}>
      <div className="search-module-results-item d-flex flex-column border-bottom w-100 py-2 px-4">
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center w-100">
            <RoundCheckbox checked={item.completed} />
            <div className="d-flex font-weight-bold ml-2 search-module-results-item-text" key={item.id}>
              <DraftEditor readOnly onChange={identity} editorState={editorStateForEditorComponent(item.body)} />
            </div>
          </div>
          <button className="btn text-primary p-0 search-module-results-item-view-button" type="button">
            View
          </button>
        </div>
        <div className="list-item-info d-flex text-muted">
          Type:
          <b className="mx-1">{meetingItemTypes[item.itemType]}</b>
          Workspace:
          <b className="mx-1">{workspaceName}</b>
        </div>
      </div>
    </div>
  );
}
